// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"wave-portable-air-conditioner_productcontent__mKHNl"};